import { render, staticRenderFns } from "./VersionInfo.vue?vue&type=template&id=538e9324&scoped=true&"
import script from "./VersionInfo.vue?vue&type=script&lang=js&"
export * from "./VersionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538e9324",
  null
  
)

export default component.exports